import React, {FC, memo, useState} from "react";
import {Button, Modal} from "antd";
import {CSVLink} from "react-csv";
import classnames from "classnames";
import moment from "moment";
import css from "./ExportModal.less";
import i18n from "../../services/i18n";
import PdfListExport from "../PdfListExport/PdfListExport";
import {CsvDataRow} from "../../helpers/tableCsvExport/getCSVData";
import DraggableModal from "../DraggableModal/DraggableModal";

export type ExportInputType = "default" | "courses";

type ExportModalProps = {
    open: boolean;
    downloadPDF: () => void;
    csvData?: Array<CsvDataRow>;
    handleCancel: () => void;
    fileName?: string;
    inputType?: ExportInputType;
    csvDataPDF?: Array<CsvDataRow>;
    csvDataCSV?: Array<CsvDataRow>;
};

const ExportModal: FC<ExportModalProps> = ({open, downloadPDF, csvData = [], handleCancel, fileName = "Export", inputType = "default", csvDataPDF, csvDataCSV, ...props}) => {
    const [useCase, setUseCase] = useState<"preview" | "export">("preview");

    const onDownload = () => {
        setUseCase("export");
        // downloadPDF();
    };

    console.log("csvData", csvData);

    return (
        <DraggableModal
            data-testid="export-modal"
            draggable={true}
            boundsPadding={500}
            bodyStyle={{padding: "5px"}}
            className={classnames(css.root, css.exportInvoiceModal)}
            open={open}
            title={`${i18n.views.ExportModal.previewPDF()} - ${fileName}`}
            onCancel={handleCancel}
            centered={true}
            maskClosable={true}
            footer={[
                <div key="exportButtons" className={classnames(css.exportButtons)}>
                    <CSVLink separator=";" data={csvDataCSV ?? csvData} filename={`${fileName}-${moment().format("YYYY-MM-DD")}.csv`} target="_blank">
                        <Button className={classnames(css.export)} key="submit">
                            {i18n.views.ExportModal.downloadCSV()}
                        </Button>
                    </CSVLink>
                    <Button className={classnames(css.export)} key="submitCSV" onClick={() => onDownload()}>
                        {i18n.views.ExportModal.downloadPDF()}
                    </Button>
                </div>,
                <Button className={classnames(css.cancel)} key="back" onClick={handleCancel}>
                    {i18n.views.ExportModal.closePreview()}
                </Button>,
            ]}
        >
            <h3 className={classnames(css.modalBody)}>
                <PdfListExport csvData={csvDataPDF ?? csvData} inputType={inputType} fileName={fileName} action={useCase} />
            </h3>
        </DraggableModal>
    );
};

export default memo(ExportModal);
